import React from "react";

import { useCompanies } from "hooks/companies";
import CadastroSimples from "../CadastroSimples";

// Tipos de serviço (Cadastros Gerais), no padrão do Hub desde a sprint 638.
// PO1-3836: modelo misto. Padrão Everlog (sem embarcador) vale para todos e só o
// Everlog Admin mantém; o cliente cadastra os tipos exclusivos do embarcador dele.
// Limites: código obrigatório até 10, nome até 100, descrição até 300.
const CONFIG = {
  url: "/cadastros/tipos-servico",
  pageClass: "tipos-servico-page",
  heroTitle: "Tipos de serviço",
  titulo: "Tipo de serviço",
  singular: "tipo de serviço",
  plural: "tipos de serviço",
  novo: "Novo tipo de serviço",
  icon: "tim-icons icon-components",
  exportFilename: "tipos_servico",
  description:
    "Tipos de serviço usados na composição das tabelas de frete e no vínculo com embarcadores e transportadoras.",
  descriptionCliente:
    "Tipos de serviço usados nas tabelas de frete e no vínculo com as transportadoras. Os padrões Everlog valem para todos; aqui você cadastra os tipos exclusivos do seu embarcador.",
  descriptionAdmin:
    "Padrões Everlog (valem para todos os embarcadores) e os tipos exclusivos de cada embarcador. Um tipo só pode virar exclusivo se nenhum outro embarcador o usa.",
  codigo: { required: true, max: 10, placeholder: "Ex.: 01" },
  nome: { max: 100 },
  descricao: { max: 300 },
};

// Produto do cliente: escopo do embarcador escolhido no topo.
const TiposServicoCliente = () => {
  const { empresa, empresaId, hasEmpresaSelection } = useCompanies();
  // "Todos os embarcadores" no topo não é um embarcador específico: lista os
  // padrões + os de todos os permitidos, mas não cadastra.
  const especifico = Boolean(hasEmpresaSelection) && empresaId !== null && empresaId !== undefined;
  return (
    <CadastroSimples
      config={CONFIG}
      escopo={{
        modo: "cliente",
        empresaId: especifico ? empresaId : null,
        empresaNome: empresa && empresa.label,
        hasEmpresaSelection: especifico,
      }}
    />
  );
};

// Everlog Admin › Cadastros globais: todos os tipos, com o escopo de cada um.
const TiposServico = ({ modo }) =>
  modo === "admin" ? <CadastroSimples config={CONFIG} escopo={{ modo: "admin" }} /> : <TiposServicoCliente />;

export default TiposServico;
